import React from "react"
import { Tabs } from "antd"
import RARTechContainer from "container/TechAssets"
import Deal from "./TabComponents/Deal"

const { TabPane } = Tabs

const HeaderTab = (props) => {
  // const {
  //   fetchReferrals,
  //   fetchAllEarnings,
  // } = props || {}

  //check here
  const onChange = (key) => {
    switch (key) {
      case "deals":
        // fetchReferrals({
        //   queryParams: "skip=0&limit=300",
        // })
        break
      default:
        return false
    }

    return true
  }

  return (
    <Tabs defaultActiveKey="deals" onChange={onChange}>
      <TabPane tab="Deals" key="deals">
        <Deal />
      </TabPane>
      {/* <TabPane tab="Financials" key="financials">
        <Financials />
      </TabPane>
      <TabPane tab="Metrics" key="details">
        <Details />
      </TabPane> */}
    </Tabs>
  )
}

export default RARTechContainer(HeaderTab)
